<template>
  <div>

    <h3>Step 3/5</h3>

    <img v-lazy="uploadedImgUrl" height="100" width="100"> <br>

    from previous route => {{$route.query}} <br>

    <div class="div-width-100">
      <div >

        <!-- search in map --> <!-- 1 -->
        <input
          id="pac-input-1"
          type="text"
          placeholder="Search Box"
        >

        <!-- locate me --> <!-- 2 -->
        <button
          @click="getCurrentGeoLocation"
          class="blue--text"
          @click.native="$store.state.uploadImage_3.getCenter=true"
          id="locBut"
        ><v-icon>location_searching</v-icon></button>

        <!-- map --> <!-- 3 -->
        <!--div id="myMap" class="div-width-100" ></div-->

        <!-- select marker loc --> <!-- 4 -->
        <button
          @click="getMarkerPosition({ // this location
             url: $route.query.url,
             resourceType: $route.query.resourceType,
             publicId: $route.query.publicId,
             //
             createdAt: $route.query.createdAt,
              //
             caption: $route.query.caption,
             emotionalAppeal: JSON.parse($route.query.emotionalAppeal)
          })"
        >
          Select Marker Location
        </button>
      </div>
    </div>

    <button
      @click="skip_uploadImage_3({ // skip //empty location
         url: $route.query.url,
         resourceType: $route.query.resourceType,
         publicId: $route.query.publicId,
         //
         createdAt: $route.query.createdAt,
         //
         caption: $route.query.caption,
         emotionalAppeal: JSON.parse($route.query.emotionalAppeal)
      })"
    >
      skip
    </button>

  </div>
</template>

<script>
  import {mapMutations} from 'vuex'
  import {mapGetters} from 'vuex'
  //
  import uploadImage from '../../mixin/uploadImage'
  //
  export default {
    //
    mixins: [
      uploadImage
    ],
    //
    methods:{
      ...mapMutations([
        'getMarkerPosition',
        'getCurrentGeoLocation',
        'skip_uploadImage_3'
      ])
    },
    computed:{
      ...mapGetters([
        'showHideMapInput',
        'showMap',
        'addressDetails'
      ])
    },
    created(){
      window.thisOfMap = this
    },
    mounted(){
      window.thisOfVueComp = this
      // now, we want address, like shopnest.
     // this.$store.commit('getMarkerOnCurrentLoc')
      this.$store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3 = this.$route.query.geoLocIsAvailable
      this.$store.state.uploadImage_3.geohash_uploadImage_3 = this.$route.query.geohash
      //console.log('UPLOAD 1',this.$store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3)
      //console.log('UPLOAD 2',this.$store.state.uploadImage_3.geohash_uploadImage_3)
    }
    //
  }
</script>
<style scoped>
  #myMap {
    height:70vh;
    width: 100%;
  }
  #pac-input-1 {
    background-color: #fff;
    font-family: Roboto;
    font-size: 15px;
    font-weight: 200;
    margin-left: 12px;
    padding: 0 11px 0 13px;
    text-overflow: ellipsis;
    width: 200px;
    height: 35px;
  }
  .true{
    visibility: visible;
  }
  .false{
    visibility: hidden;
  }

</style>



// WEBPACK FOOTER //
// uploadImage_3.vue?0d8a30a3